
export default function SideNavDirective() {
    return {
        template: require('./mobile.component.html'),
        transclude: true,
        restrict: 'E',
        controller: NavMobileController
    };
}

class NavMobileController {
    constructor($scope, $state, $location, navService) {

        'ngInject';
        
        $scope.closeSideNav = function () {
            navService.hideSideNav();
        };

        //for redirecting to specific section on the help page
        $scope.goHelp = function () {
            //help variables for page selection
            var helpPage = '';
            var helpItem = '';

            //current state and parent state variable
            var cs = $state.current.name;
            cs = cs.replace(/[0-9]/gi, '');

            var hs = $state.current.helpState;

            //set the help variables for page section
            if (cs === "help") { //if help button is clicked from same page
                cs = $location.path();
                var page = cs.split('/');
                helpPage = page[2] || null;
                helpItem = page[3] || null;
            } else { // help clicked from other page on website
                if (hs) { // if parent state available
                    var page = hs.split('.');
                    helpPage = $state.current.helpModuleId || page[0];
                    //remove integer and . from patent state to create id of the div
                    hs = hs.replace(/[-.0-9]/gi, '');
                    helpItem = hs;
                } else {
                    var page = cs.split('.');
                    helpPage = $state.current.helpModuleId || page[0];
                    cs = cs.replace(/[-.]/gi, '');
                    helpItem = cs;
                }
            }

            //convert to lowercase
            if (helpItem)
                helpItem = helpItem.toLowerCase();
            if (helpPage)
                helpPage = helpPage.toLowerCase();

            $state.go("help", {
                helpPage: helpPage,
                helpItem: helpItem
            });
        };

        $scope.selectedModule = null;

        $scope.userModule = {
            "id": "profile"
        };

        $scope.moduleStyle = function (module) {

            var style = "transition: all 0.5s;";

            if (!$scope.isActive(module)) {
                return style;
            };

            return style;
        };

        $scope.isActive = function (module) {
            return $scope.selectedModule === module;
        };

        $scope.toggleUserModule = function () {
            $scope.toggleModule($scope.userModule);
        };

        $scope.toggleModule = function (module) {
            $scope.selectedModule = $scope.isActive(module) ?
                null :
                module;
        };
    }
}
